export default __webpack_public_path__ + "static/media/Still.9e5c908e.jpg";